import { render, staticRenderFns } from "./Polling.vue?vue&type=template&id=478359b5&"
import script from "./Polling.vue?vue&type=script&lang=js&"
export * from "./Polling.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports